import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import PrtfPortfolioApiService from "../../../components/application/portfolio/Services/Api/PrtfPortfolioApi";
import store from "../index.js.erb";

const portfolioApi = PrtfPortfolioApiService

const PortfolioStore = {
    namespaced: true,
    state: ()=>({
        portfolioPerson: {},
        payloadAvatar: {
          photo: null,
        },
    }),

    getters: {
        urlPhotoPortfolio(state) {
            if (_.isEmpty(state.portfolioPerson)) return null;

            return state.portfolioPerson.photo.url
        },

        isStudent(state) {
            if (_.isEmpty(state.portfolioPerson)) return false;

            return state.portfolioPerson.person.roles.includes("student")
        },

        isTeacher(state) {
            if (_.isEmpty(state.portfolioPerson)) return false;

            return state.portfolioPerson.person.roles.includes("teacher")
        },

        personalInfo(state) {
            if (_.isEmpty(state.portfolioPerson)) return null;

            return state.portfolioPerson.person.person_info
        },

        groupStudent(state) {
            if (_.isEmpty(state.portfolioPerson)) return null;

            return state.portfolioPerson.person?.group?.name;
        },

        shortNamePerson(state) {
            if (_.isEmpty(state.portfolioPerson)) return null;

            const fullName = state.portfolioPerson.person?.full_name

            const convertFullName = fullName.split(" ");
            const surname = convertFullName[0];

            let name = "";
            if (convertFullName.length > 1) {
                name = convertFullName[1].charAt(0) + ".";
            }

            let patronymic = "";
            if (convertFullName.length > 2) {
                const firstLetterPatronymic = convertFullName[2].charAt(0) + ".";
                patronymic = " " + firstLetterPatronymic;
            }

            return surname + " " + name + patronymic;
        },
    },

    mutations: {
        setPortfolioPerson(state, response) {
            state.portfolioPerson = response;
        },

        setAchievementsListPortfolio(state, achievementsList) {
            Vue.set(state.portfolioPerson, 'achievements', achievementsList);
        },

        setPortfolioAvatar(state, file) {
            state.payloadAvatar.photo = file;
        },
    },

    actions: {
        async getPortfolioPerson({commit}) {
            const response = await portfolioApi.index();
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setPortfolioPerson", response.data.portfolio);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.message,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async editAvatarPortfolio({state, commit}) {
            const response = await portfolioApi.editAvatarPortfolio(state.payloadAvatar);
            if (_.isNull(response)) return;

            if (!response.data.hasOwnProperty("error")) {
                const photo = response.data?.portfolio?.photo;
                Vue.set(state.portfolioPerson, 'photo', photo);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.message,
                    context: "Error Server",
                    show: true
                });
            }
        },

    },
}

export default PortfolioStore